// extracted by mini-css-extract-plugin
export default {"container":"Home_container__1DCHt","flex-row":"Home_flex-row__j9kwL"};